import { render, staticRenderFns } from "./AcceptTermsAndPolicies.vue?vue&type=template&id=87989a26&scoped=true"
import script from "./AcceptTermsAndPolicies.vue?vue&type=script&lang=ts"
export * from "./AcceptTermsAndPolicies.vue?vue&type=script&lang=ts"
import style0 from "./AcceptTermsAndPolicies.vue?vue&type=style&index=0&id=87989a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87989a26",
  null
  
)

export default component.exports